import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { AgrPageModule } from '@next/core-lib/components';

import { AgrFormModule } from '@next/core-lib/form';

import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

import { AppWizardComponent } from './app-wizard.component';

import { SharedModule } from '../shared/shared.module';

import { AppWizardCreateComponent } from './app-wizard-create/app-wizard-create.component';
import { AppWizardCreateGroupComponent } from './app-wizard-create-group/app-wizard-create-group.component';
import { AppWizardDeleteComponent } from './app-wizard-delete/app-wizard-delete.component';
import { AppWizardDeleteGroupComponent } from './app-wizard-delete-group/app-wizard-delete-group.component';
import { AppWizardEffects } from './store/effects/app-wizard.effects';
import { appWizardReducer } from './store/reducers/app-wizard.reducers';

@NgModule({
  declarations: [
    AppWizardComponent,
    AppWizardCreateComponent,
    AppWizardDeleteComponent,
    AppWizardCreateGroupComponent,
    AppWizardDeleteGroupComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgrPageModule,
    MatStepperModule,
    MatFormFieldModule,
    AgrFormModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
  ],
  providers: [
    provideState('appWizardModule', appWizardReducer),
    provideEffects([AppWizardEffects]),
  ],
})
export class AppWizardModule {}
